/*
 * @Author       : zxlin
 * @Date         : 2023-07-06 11:34:05
 * @LastEditors  : zxlin
 * @LastEditTime : 2024-04-08 09:15:42
 * @FilePath     : \h5-vue3-template\src\main.js
 * @Description  :
 */
import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import "@/styles/index.less";
import VConsole from "vconsole";
import { Toast, Button, Tabbar, TabbarItem, NavBar, CellGroup, Progress, Tag, Empty, Loading } from "vant";
import "vant/lib/index.css";
import um from "@/directives/um";
// 万年历工具类挂载window
import "@/utils/wnl-util";
// 使用rem适配
// import '@/utils/window-recalc';
// 如果页面需要转繁体,打开下面注释
// import 'lang-hant'
// 性能
import "@/utils/perf";
// 页面加载防止闪动
import "./utils/share";
import {store} from './store';
// vconsole
try {
  if (window.location.href.includes("debugger")) {
    const vConsole = new VConsole({ theme: "dark" });
  }
} catch (e) {}
const app = createApp(App);
app.use(router);
app.use(store)
// 友盟点击埋点指令
app.directive("um", um);
app.mount("#app");
app.use(Toast).use(Button).use(Tabbar).use(TabbarItem).use(NavBar).use(CellGroup).use(Progress).use(Tag).use(Empty).use(Loading);
